import * as Yup from 'yup'

export const getInitialValues = editItem => ({
  code: editItem?.code || '',
  name: editItem?.name || '',
  country: editItem?.country
    ? {
        label: editItem.country.name,
        value: editItem.country.id
      }
    : null,
  isEnabled: editItem?.isEnabled ?? true
})

export const getValidationSchema = () =>
  Yup.object().shape({
    code: Yup.string().required('Code is required'),
    name: Yup.string().required('Name is required'),
    country: Yup.object()
      .shape({
        label: Yup.string().required('Country is required'),
        value: Yup.string().required('Country is required')
      })
      .required('Country is required'),
    isEnabled: Yup.boolean().required('Status is required')
  })
